module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', [(_vm.currentFluxer[0]) ? _c('div', {
    staticClass: "reporte-feedbacks"
  }, [_c('headerFeed', {
    attrs: {
      "currentUser": _vm.currentUser,
      "title": "Reportes de Feedbacks"
    }
  }), _vm._v(" "), _c('md-spinner', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loader),
      expression: "loader"
    }],
    attrs: {
      "md-indeterminate": ""
    }
  }), _vm._v(" "), (_vm.currentFluxer[0].admin) ? _c('md-table', [_c('md-table-header', [_c('md-table-row', [_c('md-table-head', [_vm._v("Estado")]), _vm._v(" "), _c('md-table-head', [_vm._v("Tipo")]), _vm._v(" "), _c('md-table-head', [_vm._v("Dueño")]), _vm._v(" "), _c('md-table-head', [_vm._v("Editor")]), _vm._v(" "), _c('md-table-head', [_vm._v("Fecha de solicitud")]), _vm._v(" "), _c('md-table-head', [_vm._v("Fecha de completado")])], 1)], 1), _vm._v(" "), _c('md-table-body', _vm._l((_vm.allFeedbacks), function(feed, index) {
    return _c('md-table-row', {
      key: index,
      nativeOn: {
        "click": function($event) {
          _vm.openDetail(feed)
        }
      }
    }, [(feed.completed) ? _c('md-table-cell', [_vm._v("Finalizado")]) : _c('md-table-cell', [_vm._v("Pendiente")]), _vm._v(" "), (!feed.isEspontaneo) ? _c('md-table-cell', [_vm._v(_vm._s(feed.tipo))]) : _vm._e(), _vm._v(" "), (feed.isEspontaneo) ? _c('md-table-cell', [_vm._v("Espontaneo")]) : _vm._e(), _vm._v(" "), _c('md-table-cell', [_vm._v(_vm._s(feed.owner))]), _vm._v(" "), _c('md-table-cell', [_vm._v(_vm._s(feed.editor))]), _vm._v(" "), _c('md-table-cell', [_vm._v(_vm._s(_vm._f("moment")(feed.created, "YYYY/MM/DD - HH:mm")))]), _vm._v(" "), (feed.completed) ? _c('md-table-cell', [_vm._v(_vm._s(_vm._f("moment")(feed.completed, "YYYY/MM/DD - HH:mm")))]) : _c('md-table-cell', [_vm._v("-")])], 1)
  }))], 1) : _vm._e()], 1) : _c('div', [_vm._v("\n      Necesita ser Administrador de la app para ver esta seccion\n  ")]), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-149fd5af"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ReporteFeedbacks.vue
// module id = 369
// module chunks = 1